<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        สถานที่บริษัทและสาขา
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!formShow">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            placeholder="รหัส - ชื่อสถานที่"
            @input="handleSearch"
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-autocomplete
            v-model="filterLocationType"
            :items="locationTypes"
            :loading="loadingLocationTypes"
            item-text="title_th"
            item-value="location_type_code"
            label="ประเภทสถานที่"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            style="width: 220px; background-color: white; margin-right: 5px"
            @change="handleFilterLocationType"
          ></v-autocomplete>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:create')
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddCompanyLocation"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มสถานที่
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :headers="headers"
      :items="companyLocations"
      :options.sync="options"
      :server-items-length="totalCompanyLocations"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.latitude="{ item }">
        {{
          item.latitude.split('.')[0] +
          item.latitude.substr(item.latitude.indexOf('.'), 6)
        }}
      </template>
      <template v-slot:item.longitude="{ item }">
        {{
          item.longitude.split('.')[0] +
          item.longitude.substr(item.longitude.indexOf('.'), 6)
        }}
      </template>
      <template v-slot:item.location_type="{ item }">
        <v-chip small color="cyan darken-1" text-color="white">
          {{ item.location_type.title_th }}
        </v-chip>
      </template>
    </v-data-table>
    <CompanyLocationForm
      :formShow="formShow"
      :formAction="formAction"
      :companyLocation="companyLocation"
      :companyLocationInit="companyLocationInit"
      @isCompanyLocationDataChange="handleCompanyLocationFormDataChange"
      @formActionCompleted="handleCompanyLocationFormActionCompleted"
      @onReset="handleCompanyLocationFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="formShow && formAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import CompanyLocationForm from '@/views/company-location/CompanyLocationForm.vue'

export default {
  components: {
    CompanyLocationForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['company_location_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loadingLocationTypes: false,
      filterLocationType: null,
      options: {},
      loading: false,
      search: '',
      headers: [
        {
          text: 'รหัสสถานที่',
          value: 'company_location_code',
          class: 'text-no-wrap',
        },
        { text: 'ชื่อสถานที่', value: 'title_th', class: 'text-no-wrap' },
        {
          text: 'ชื่อสถานที่ (อังกฤษ)',
          value: 'title_en',
          class: 'text-no-wrap',
        },
        {
          text: 'ประเภทสถานที่',
          value: 'location_type',
          class: 'text-no-wrap',
          sortable: false,
        },
        { text: 'ละติจูด', value: 'latitude', class: 'text-no-wrap' },
        { text: 'ลองจิจูด', value: 'longitude', class: 'text-no-wrap' },
        { text: 'รัศมี (เมตร)', value: 'radius_meter', class: 'text-no-wrap' },
        { text: 'Timezone', value: 'timezone', class: 'text-no-wrap' },
      ],
      formShow: false,
      formAction: '',
      companyLocation: {},
      companyLocationInit: {},
      isCompanyLocationDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
    companyLocations() {
      return this.$store.state.companyLocation.companyLocations
    },
    totalCompanyLocations() {
      return this.$store.state.companyLocation.totalCompanyLocations
    },
    locationTypes() {
      return this.$store.state.locationType.locationTypes.filter(
        (type) =>
          type.location_type_code === 'hq' ||
          type.location_type_code === 'branch'
      )
    },
  },
  watch: {
    options: {
      handler() {
        this.getCompanyLocations()
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สถานที่บริษัทและสาขา',
        disabled: true,
      },
    ])

    try {
      this.loadingLocationTypes = true
      await this.fetchLocationTypes({
        params: {
          sort: 'display_order:asc',
        },
      })
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingLocationTypes = false
    }
  },
  methods: {
    ...mapActions({
      fetchCompanyLocations: 'companyLocation/fetchCompanyLocations',
      fetchLocationTypes: 'locationType/fetchLocationTypes',
    }),
    handleSearch() {
      this.getCompanyLocationsBySearch()
    },
    getCompanyLocationsBySearch: _.debounce(function () {
      this.options.page = 1
      this.getCompanyLocations()
    }, 500),
    handleFilterLocationType() {
      this.options.page = 1
      this.getCompanyLocations()
    },
    classRowSelected(row) {
      if (
        this.companyLocation.company_location_uuid === row.company_location_uuid
      )
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::company_location:get')) {
        this.dialogForbidden = true
        return
      }

      if (
        this.companyLocation.company_location_uuid === row.company_location_uuid
      ) {
        this.formShow = false
        this.formAction = ''
        this.companyLocation = {}
        this.companyLocationInit = {}

        this.$store.commit('googleMap/SET_MARKERS', [])
        this.$store.commit('googleMap/SET_MARKERS_INIT', [])
      } else {
        this.formShow = true
        this.formAction = 'edit'
        this.companyLocation = { ...row }
        this.companyLocationInit = { ...row }

        const markers = []
        const latLng = {
          lat: parseFloat(row.latitude),
          lng: parseFloat(row.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
        this.$store.commit('googleMap/SET_MARKERS_INIT', markers)
      }
    },
    handleRowSelected(row) {
      if (this.isCompanyLocationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddCompanyLocation() {
      this.formShow = true
      this.formAction = 'add'

      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$store.commit('googleMap/SET_MARKERS_INIT', [])
    },
    handleCompanyLocationFormDataChange(value) {
      this.isCompanyLocationDataChange = value
    },
    handleCompanyLocationFormReset(formAction) {
      if (formAction === 'edit') {
        this.$store.commit(
          'googleMap/SET_MARKERS',
          JSON.parse(JSON.stringify(this.markersInit))
        )
        this.companyLocation = { ...this.companyLocationInit }
      }
    },
    handleCompanyLocationFormActionCompleted(formAction) {
      this.companyLocation = {}
      this.companyLocationInit = {}

      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$store.commit('googleMap/SET_MARKERS_INIT', [])

      this.formShow = false
      this.formAction = ''
    },
    async getCompanyLocations() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        const sortKey = [...sortBy]

        const sortParams = sortKey
          .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
          .join(',')

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            search: this.search || undefined,
            location_type_code: this.filterLocationType || undefined,
            sort: sortParams || undefined,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
        }

        this.loading = true
        await this.fetchCompanyLocations(payload)
        this.loading = false
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.$store.commit('googleMap/SET_MARKERS', [])
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCompanyLocationDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
